import { forwardRef, useImperativeHandle, useRef } from 'react';
export default forwardRef(function DateInput({value, onChange, style, ...rest}, ref) {
  const inputRef=useRef(null);
  useImperativeHandle(ref,()=>({
    focus(){inputRef.current?.focus();try{inputRef.current?.showPicker();}catch(_){}},
    get value(){return inputRef.current?.value;},
  }));
  return <input ref={inputRef} type="date" value={value} onChange={onChange}
    onFocus={e => { try { e.target.showPicker(); } catch (_) {} }}
    style={style} {...rest}/>;
});
